import { ITypedReduxAction } from '../../types/redux/actionType';
import { IPostContentExpertBlock } from '../../types/postContentExpertBlocks';

export enum EPostContentExpertBlockActionType {
  Set = 'postContentExpertBlock/set',
  Reset = 'postContentExpertBlock/reset',
}

export type TPostContentExpertBlockSet = ITypedReduxAction<
  EPostContentExpertBlockActionType.Set,
  IPostContentExpertBlock
>;

export type TPostContentExpertBlockReset = ITypedReduxAction<EPostContentExpertBlockActionType.Reset>;

export type TPostContentExpertBlockActions = TPostContentExpertBlockSet | TPostContentExpertBlockReset;
